'use es6';

import getLang from 'LearningCenterUI/utils/getLang';
import { normalizeTrackResponse } from 'academy-shared-js/utils/NormalizationUtils';
import { List, Map as ImmutableMap, fromJS } from 'immutable';
import Raven from 'raven-js';
import { fetchTrackById, fetchAllPublicTracks, fetchAllPartnerTracks } from '../features/tracks';
import ActionTypes from './ActionTypes';
import responseMapper from 'academy-shared-js/utils/responseMapper';
import { shouldFetch, shouldFetchWithCache } from '../utils/ActionUtils';
import { ACADEMY_TRACKS_REDUCER_KEY } from '../constants/CourseConstants';
try {
  localStorage.removeItem(ACADEMY_TRACKS_REDUCER_KEY);
} catch (error) {
  Raven.captureException(error);
}
export function trackByIdRequesting(id) {
  return {
    type: ActionTypes.TRACK_BY_ID_REQUESTING,
    meta: {
      id
    }
  };
}
function trackByIdReceived(payload, requestLanguage) {
  const normalized = normalizeTrackResponse(responseMapper(payload));
  return {
    type: ActionTypes.TRACK_BY_ID_RECEIVE,
    payload: Object.assign({}, normalized, {
      tracksById: normalized.tracksById.map(track => track.toMap().set('lessonIds', track.get('lessons')).set('examId', track.get('exam')).set('duration', payload.duration).set('hsSoftwareFilters', payload.hsSoftwareFilters).set('subCategories', List(payload.subCategories)).set('requestLanguage', requestLanguage).remove('lessons')),
      lessonsById: normalized.lessonsById.map(lesson => lesson.toMap().set('contentIds', lesson.get('content')).set('requestLanguage', requestLanguage).remove('content'))
    })
  };
}
function trackByIdRequestError(error, id) {
  return {
    type: ActionTypes.TRACK_BY_ID_ERROR,
    error: true,
    payload: error,
    meta: {
      id
    }
  };
}
export function getTrackById(id, lang) {
  return dispatch => {
    dispatch(trackByIdRequesting(id));
    return fetchTrackById(id, lang).then(response => dispatch(trackByIdReceived(response, lang)), errorResponse => dispatch(trackByIdRequestError(errorResponse, id)));
  };
}
export function fetchTrackByIdIfNeeded(trackId, lang = getLang()) {
  return (dispatch, getState) => {
    const thisTrackState = getState().tracks.getIn(['tracksById', trackId]);
    if (shouldFetch(thisTrackState, lang)) {
      dispatch(getTrackById(trackId, lang));
    }
  };
}
function tracksRequesting(isPartner = false) {
  return {
    type: ActionTypes.TRACKS_REQUESTING,
    meta: {
      isPartner
    }
  };
}
function tracksByIdReceived(response, requestLanguage, isPartner = false) {
  const tracksById = fromJS(response.result).reduce((map, track) => {
    const stringifiedIDs = track.merge({
      id: track.get('id').toString(),
      examId: track.get('examId') && track.get('examId').toString(),
      lessonIds: track.get('lessonIds').map(lessonId => lessonId.toString()),
      requestLanguage,
      lastValidResult: 0
    });
    return map.set(stringifiedIDs.get('id'), stringifiedIDs);
  }, new ImmutableMap());
  return {
    type: ActionTypes.TRACKS_BY_ID_RECEIVED,
    payload: {
      tracksById
    },
    meta: {
      totalCount: response.result.totalCount,
      timestamp: response.timestamp,
      isPartner
    }
  };
}
function tracksRequestError(error) {
  return {
    type: ActionTypes.TRACKS_ERROR,
    error: true,
    payload: error
  };
}
export function fetchPublicTracks(language = getLang()) {
  return dispatch => {
    dispatch(tracksRequesting());
    fetchAllPublicTracks(language).then(result => dispatch(tracksByIdReceived(result, language))).catch(errorResponse => dispatch(tracksRequestError(errorResponse)));
  };
}
export function fetchPartnerTracks(language = getLang()) {
  return dispatch => shouldFetchWithCache(fetchAllPartnerTracks, () => dispatch(tracksRequesting(true)), {
    language
  }).then(response => dispatch(tracksByIdReceived(response, language, true)), errorResponse => dispatch(tracksRequestError(errorResponse))).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
}